import React, { useEffect, useRef, useState } from 'react';
import MainContext from '../contexts/MainContext';
import { BetslipContext } from '../data/betslip/BetslipConf';
import { SERVING_SPORTS } from '../data/constants';
import { getStreamingId } from '../data/streaming/streamingUtils';
import { classIf, getConfiguration, getMatchIdOrStageId, getPrincipaleOPrimoGruppo, iconCategoryCssClass } from '../data/utils';
import { WidgetContext } from '../data/widgets/WidgetContext';
import { LiveSectionContext } from '../live/common/LiveSection';
import StreamingIcon from '../live/common/StreamingIcon';
import MoreBets from '../prematch/prematch-home/MoreBets';
import { checkForDashClass } from '../tables-utils';
import FastbetDropdown from './../common/FastbetDropdown';
import { FavoritesContext } from './FavoritesContextProvider';
import OddsList from './OddsList';
import OpenLiveMatchButton from './OpenLiveMatchButton';
import PartialScores from './PartialScores';
import Img from './util/Img';
import Jersey from '../data/jerseys/Jersey';
import StatsToggle from './StatsToggle';
import LiveScoresInlineNewWh from './LiveScoresInlineNewWh';

function TournamentLiveMatch(props) {
    const conf = getConfiguration();
    const mainContext = React.useContext(MainContext);
    const liveSectionContext = React.useContext(LiveSectionContext);
    const favoritesContext = React.useContext(FavoritesContext);
    const widgetContext = React.useContext(WidgetContext);
    const streamingId = getStreamingId(props.streaming);
    const streamingInfo = props.streaming;
    const betslipContext = React.useContext(BetslipContext);

    const match = props.match;
    const isInBetslip = betslipContext.isEventSelected(match.pal, match.avv);
    const isFavorite = favoritesContext.favorites[match.uniqueId] !== undefined;

    const [toggled, setToggled] = useState(false);
    function toggleMoreBets() {
        if (props.moreBetsEnabled) {
            setToggled(!toggled);
        }
    }

    function handleClick() {
        props.changeMatch(match);
    }

    function toggleWidgetMatch(containerId) {
        if (widgetContext.widgetMatchId === match.id) {// se widget gia' aperto lo chiudo
            closeWidgetMatch();
        } else {// apro il widget
            openWidgetMatch(containerId, match)
        }
    }

    function closeWidgetMatch() {
        widgetContext.setWidget({
            widgetMatchId: null
        });
    }

    function openWidgetMatch(containerId, match) {
        closeStreaming();
        widgetContext.setWidget({
            widgetGeniusId: match.geniusId,
            widgetLsportId: match.lsportWidgetId,
            widgetProviderType: match.widgetType,
            widgetMatchId: getMatchIdOrStageId(match),
            widgetContainerId: containerId
        });
    }

    function handleWidgetButton() {
        if (!match.sportRef) {
            handleClick();
            closeStreaming();
            return;
        }

        const settings = {};
        if (props.isLiveSuite) {
            Object.assign(settings, {
                widgetStartCollapsed: true,
                widgetShowSidebar: false,
                widgetS5Layout: '#3'
            });
            if (!favoritesContext.showFavourites && props.selected) {
                toggleWidgetMatch("#collassaWidgetCompetition");
            } else {
                Object.assign(settings, {
                    widgetContainerId: null, //imposto container null, il container lo decide il component che visualizza il match
                    widgetMatchId: getMatchIdOrStageId(match)
                });
                props.changeMatch(match);
                closeStreaming();
            }
        } else {
            Object.assign(settings, {
                widgetShowSidebar: false,
                widgetStartCollapsed: false,
                widgetS5Layout: '#2'
            });
            toggleWidgetMatch("#collassaWidget");
        }

        widgetContext.setWidget(settings);
    }

    function handleStreamingButton() {
        closeWidgetMatch();
        if (props.isLiveSuite) {
            if (props.selected) {
                //mainContext.toggleStreamingGeniusFid(props.streaming.fid);
                mainContext.toggleStreaming(streamingInfo, streamingId, match.id);
            } else {
                //mainContext.toggleStreamingGeniusFid(props.streaming.fid);
                widgetContext.setWidget({
                    isWidgetToggleable: false
                });
                props.changeMatch(match);
                setTimeout(() => {
                    closeWidgetMatch();
                    mainContext.toggleStreaming(streamingInfo, streamingId, match.id);
                }, 1000);
            }
        } else {
            //mainContext.toggleStreamingGeniusFid(props.streaming.fid,'betslip');
            closeWidgetMatch();
            mainContext.toggleStreaming(streamingInfo, streamingId, match.id, 'betslip');
        }
    }

    function closeStreaming() {
        //mainContext.toggleStreamingGeniusFid(null);
        if (!conf.lstwc) {
            mainContext.toggleStreaming(null, null, null);
        }
    }

    function toggleFavorite() {
        favoritesContext.toggleFavorite(match, getPrincipaleOPrimoGruppo(match.gruppiScommessa).idAggregata);
    }

    useEffect(() => {
        const settings = {
            widgetGeniusId: match.geniusId,
            widgetLsportId: match.lsportWidgetId,
            widgetProviderType: match.widgetType,
            widgetSportId: match.sportRef
        };
        if (props.isLiveSuite && widgetContext.isWidgetToggleable && (props.selected || liveSectionContext.currentMatch === match.id)) {
            Object.assign(settings, {
                widgetStartCollapsed: true,
                widgetS5Layout: '#3',
                widgetContainerId: null, //imposto container null, il container lo decide il component che visualizza il match
                widgetMatchId: getMatchIdOrStageId(match)
            });
        }
        widgetContext.setWidget(settings);
    }, [liveSectionContext.currentMatch]);

    useEffect(() => {
        if (mainContext.streamingId == null) {
            widgetContext.setWidget({
                isWidgetToggleable: true
            });
        }
    }, [mainContext.streamingId]);

    // Adatta il nome del match in base allo spazio disponibile
    const matchDesc = useRef(null);
    useEffect(() => {
        const handler = () => {
            if (matchDesc.current != null) {
                checkForDashClass(matchDesc.current);
            }
        };

        handler();
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        }
    }, []);

    return (
        <>
            <div key={"tournament-match-" + match.id} className={"tabellaQuoteNew" + (streamingId ? ' tabellaQuoteNew--hasStreaming' : '') + " text_s1 mb-2" + (isInBetslip ? ' event-row-selected' : '')}>
                {conf.iwh ?
                    <>
                        <div className='matchScore__currentMinute'>
                             <div className='matchScore__periodo'>{match.score.periodo}</div> 
                             {/* <PartialScores match={match} />  */}
                        <div className='matchScore__currentMinute'> {match.score.currentMinute }</div></div>
                        <LiveScoresInlineNewWh data={match.score} sportType={match.sportDesc} />
                    </>
                    :
                    (<>
                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                            {/*  <div className={"fa fa-star ml-2 mr-2 pointer" + classIf(isFavorite, 'giallo')} onClick={toggleFavorite}></div> */}
                            <div className="tempo-live text-center">
                                <span className="fraz-gioco colore-1 margine-dx-mezzo">{match.score.periodo}</span>
                                {match.score.currentMinute &&
                                    <span className="lampeggia tempo-live">{match.score.currentMinute}</span>
                                }
                                <div className="risultato-live grassetto">
                                    <span>{match.score.combinedScore}</span>
                                </div>
                            </div>
                        </div>
                        <div className="tabellaQuoteCampetto">
                            <Img src="assets/images/widget-campetto.png" width="20px" height="14px" className="pointer" alt="Open widget" onClick={handleWidgetButton} />
                            {streamingId &&
                                <StreamingIcon src="assets\img\sport\icone\tv-streaming.svg" alt="" className="pointer img-tv-streaming" onClick={handleStreamingButton} />
                            }
                        </div></>)
                }
                {/* <div ref={matchDesc} className="tabellaQuoteSquadre pointer" onClick={props.isLiveSuite?handleWidgetButton:handleClick}> */}
                {liveSectionContext.sortType !== 'league' ?
                    <div className="tabellaQuoteSquadreContainer">
                        <span className={"img-fluid ico-cat mr-2 " + (iconCategoryCssClass(match.sportRef, match.categoryRef, match.iconClass))}></span>
                        <div ref={matchDesc} className="tabellaQuoteSquadre pointer" onClick={handleClick}>
                            {SERVING_SPORTS.includes(match.sportRef) ?
                                <>
                                    <p className={`font-weight-bold m-0 text-right ${match.score.srv === 1 ? 'serving' : 'not-serving'}`} title={match.team1}>
                                        <span>
                                            <Img src={match.score.sourceServing} alt="" />
                                            {match.team1}
                                        </span>
                                    </p>
                                    {match.team2 != null &&
                                        <>
                                            <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                            <p className={`font-weight-bold m-0 text-left ${match.score.srv === 2 ? 'serving' : 'not-serving'}`} title={match.team2}>
                                                <span>
                                                    <Img src={match.score.sourceServing} alt="" />
                                                    {match.team2}
                                                </span>
                                            </p>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    <div className="d-flex items-center">
                                        {match.team2 &&
                                            <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                        }
                                        <p className={'font-weight-bold m-0 text-right'} title={match.team1}>
                                            <span>{match.team1}</span>
                                        </p>
                                    </div>
                                    {match.team2 != null &&
                                        <>
                                            <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                            <div className="d-flex items-center">
                                                <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                                <p className={'font-weight-bold m-0 text-left'} title={match.team2}><span>{match.team2}</span></p>
                                            </div>
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    :
                    <div ref={matchDesc} className="tabellaQuoteSquadre pointer" onClick={handleClick}>
                        {SERVING_SPORTS.includes(match.sportRef) ?
                            <>
                                <p className={`font-weight-bold m-0 text-right ${match.score.srv === 1 ? 'serving' : 'not-serving'}`} title={match.team1}>
                                    <span>
                                        <Img src={match.score.sourceServing} alt="" />
                                        {match.team1}
                                    </span>
                                </p>
                                {match.team2 != null &&
                                    <>
                                        <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                        <p className={`font-weight-bold m-0 text-left ${match.score.srv === 2 ? 'serving' : 'not-serving'}`} title={match.team2}>
                                            <span>
                                                <Img src={match.score.sourceServing} alt="" />
                                                {match.team2}
                                            </span>
                                        </p>
                                    </>
                                }
                            </>
                            :
                            <>
                                <div className="d-flex items-center">
                                    {match.team2 &&
                                        <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                    }
                                    <p className={'font-weight-bold m-0 text-right'} title={match.team1}>
                                        <span>{match.team1}</span>
                                    </p>
                                </div>
                                {match.team2 != null &&
                                    <>
                                        <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                        <div className="d-flex items-center">
                                            <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                            <p className={'font-weight-bold m-0 text-left'} title={match.team2}>
                                                <span>{match.team2}</span>
                                            </p>
                                        </div>
                                    </>
                                }
                            </>
                        }
                    </div>
                }
                <div className="tabellaQuoteStatistiche">
                    <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={match} />
                </div>
                <div className="tabellaQuoteAltre d-flex justify-content-end align-items-center pr-2">
                    {match.gruppiScommessa.length > 1 &&
                        <FastbetDropdown id={match.id} match={match} toggleMoreBets={toggleMoreBets} moreBetsToggled={toggled} />
                    }
                    {props.isLiveSuite &&
                        <OpenLiveMatchButton match={match} />
                    }
                </div>
                <div className="tabellaQuoteContenitoreQuotazioni">
                    <OddsList {...match} />
                </div>
                {!conf.iwh &&
                    <div className="tabellaQuoteRisultatiParziali">
                        <div className="tabellaQuoteRisultatiParziali-contenitoreRisultati">
                            <div className={"fa fa-star ml-2 mr-2 pointer" + classIf(isFavorite, 'giallo')} onClick={toggleFavorite}></div>
                            <PartialScores match={match} />
                        </div>
                    </div>
                }
            </div>
            {props.moreBetsEnabled && toggled &&
                <MoreBets match={match} />
            }
        </>
    );
}

export default TournamentLiveMatch;
